import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const sized = (url, w) => (url.includes('cloudinary.com') ? url.replace('/upload/', `/upload/w_${w},q_auto,f_auto/`) : url);

export const CustomerPhotoGrid = ({ photos }) => {
  const [open, setOpen] = useState(null);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && setOpen(null);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  return (
    <>
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [&>*]:mb-5" data-testid="customer-photo-grid">
        {photos.map((p, i) => (
          <button
            key={p.id}
            onClick={() => setOpen(p)}
            className="block w-full overflow-hidden rounded-2xl border border-white/10 bg-slate-900 break-inside-avoid group"
            style={{ animation: `fadeIn 0.5s ease ${Math.min(i, 12) * 60}ms both` }}
            data-testid={`customer-photo-${p.id}`}
          >
            <img
              src={sized(p.url, 700)}
              alt="Client Entrepôt Auto Montréal"
              loading="lazy"
              className="w-full h-auto transition-transform duration-500 group-hover:scale-105"
            />
          </button>
        ))}
      </div>
      {open && (
        <div
          className="fixed inset-0 z-[10000] bg-black/90 backdrop-blur-md flex items-center justify-center p-4"
          onClick={() => setOpen(null)}
          data-testid="customer-photo-lightbox"
        >
          <button className="absolute top-4 right-4 text-white p-2 rounded-full bg-white/10 hover:bg-white/20" data-testid="customer-photo-lightbox-close">
            <X className="h-5 w-5" />
          </button>
          <img src={sized(open.url, 1600)} alt="Client Entrepôt Auto Montréal" className="max-h-[90vh] max-w-full rounded-xl" />
        </div>
      )}
    </>
  );
};
